// "The Last 10% Is Trust, Not Code" — solo-dev enterprise-RAG short.
// Cold Compute / Neon kit. ~138s @ 30fps. Grounded in EAKC-MVP code/migrations.
export { FPS, WIDTH, HEIGHT } from "../../coldcompute/theme";

// Scene frame-timing map. start/duration in frames; contiguous (next.start = prev.start + prev.duration).
export const SCENE = {
  hook: { start: 0, duration: 150 }, //        0:00–0:05  the last 10% almost shipped a lie
  ninety: { start: 150, duration: 420 }, //    0:05–0:19  the easy 90%: features
  failure: { start: 570, duration: 510 }, //   0:19–0:36  the confident-wrong answer
  grounding: { start: 1080, duration: 540 }, // 0:36–0:54  numeric grounding hard-block
  gate: { start: 1620, duration: 480 }, //     0:54–1:10  the output gate + 35 blocks
  probe: { start: 2100, duration: 540 }, //    1:10–1:28  the recency probe (measure it)
  honest: { start: 2640, duration: 480 }, //   1:28–1:44  the honest reality check
  outro: { start: 3120, duration: 330 }, //    1:44–1:55
} as const;

export const TOTAL_DURATION = 3450; // 115s — verified contiguous sum below
// hook150 + ninety420 + failure510 + grounding540 + gate480 + probe540 + honest480 + outro330 = 3450 (115s)

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
